<template>
  <div class="bg-white rounded-sm text-gray mx-2 my-3 px-2">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
